import { cn } from "../../lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    (<div
      className={cn("rounded-md bg-primary/10 dark:bg-gray-200", className)}
      {...props} />)
  );
}

export { Skeleton }
